/**
 * Brand tokens from Katie's brand kit: Deep Teal #083534, Terracotta #D58073, Linen #F7F4F2.
 * Every other token is a tint or shade of those three. Single source of truth for mobile, web and admin.
 *
 * Contrast (WCAG 2.x, against linen and white): ink 12:1+, inkSoft 7:1+, muted 4.9:1, roseDeep 4.6:1,
 * so all four are safe for small text. `rose` itself is 2.7:1 on linen: fills and large art only, never text.
 */
export const colors = {
    ink: "#083534",
    inkSoft: "#2F5553",
    muted: "#5A6E6C",
    /** Placeholders and decorative strokes only. */
    subtle: "#93A09E",
    rose: "#D58073",
    /** Terracotta shade for small text (eyebrows, captions). */
    roseDeep: "#A9564A",
    cream: "#F7F4F2",
    blush: "#F5E1DC",
    butter: "#F8EDD6",
    mist: "#E7F0EF",
    sage: "#CFE0DE",
    seafoam: "#B3D3D0",
    line: "#E4DFDB",
    white: "#FFFFFF",
    success: "#52A278",
    /** Logo artwork colors (icon, splash). */
    logoInk: "#083534",
    logoRose: "#D58073",
    danger: "#C2544D",
};
/**
 * Avatar backgrounds. Initials are always drawn in `colors.ink`; every swatch keeps
 * contrast ≥ 4.5:1 against it (see brand.test.ts).
 */
export const avatarPalette = [
    "#EBA7A1", // terracotta tint (stored on existing profiles; keep the value)
    "#B6D8D2", // seafoam
    "#F4D78F", // butter gold
    "#C7B5D8", // lilac
    "#F4DED9", // blush
    "#D1E2DF", // sage
    "#F2C1A0", // peach
    "#BFD7EA", // sky
];
export function randomAvatarColor(rand = Math.random) {
    return avatarPalette[Math.floor(rand() * avatarPalette.length)];
}
export function initialsOf(firstName, lastName) {
    const f = firstName.trim().charAt(0);
    const l = lastName.trim().charAt(0);
    return (f + l).toUpperCase();
}
/** Ink on rose is 4.6:1 (AA); CTAs still keep labels large and bold for comfort. */
export const ROSE_CTA_MIN_FONT_SIZE = 19;
export const fonts = {
    heading: "Lato",
    text: "Open Sans",
};
export const radii = { sm: 8, md: 12, lg: 18, xl: 24, pill: 999 };
export const space = { xs: 4, sm: 8, md: 12, lg: 16, xl: 20, xxl: 28 };
//# sourceMappingURL=brand.js.map